import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import {
  APPROVAL_TABLE_HEAD_BG,
  approvalFormTableStyles,
} from '@/components/Approval/@components/ApprovalFormTable/styles';

/** V2 카드·레거시 문서 카드 모두 태그·클래스로 스타일링 */
export const InventoryReplenishmentRoot = styled(Box)(({ theme }) => ({
  width: '100%',
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  '& table': { ...approvalFormTableStyles(theme), minWidth: 800 },
  '& .text-center': { textAlign: 'center' },
  '& th.card-title': { fontWeight: 600 },
  '& th.irp-action': { textAlign: 'right' },
  // 레거시 문서는 머리글이 td.bg-* 로 저장됨
  '& td.bg-title, & th.bg-gray, & th.bg-gray2': {
    backgroundColor: APPROVAL_TABLE_HEAD_BG,
    fontWeight: 500,
  },
}));
